export default {
  textTransform: 'uppercase',
} as const;
